// YoutubeModal
$(function(){
  let modalBtn = $('.js-modal__btn');
  let modalBtnClose = $('.js-modal__btn--close');
  let modalBtnCloseFix = $('.js-modal__btn--close--fix');
  let modalBg = $('.js-modal__bg');
  let modalMain = $('.js-modal__main');
  modalBtn.on('click', function (e) {
    $(this).next(modalBg).fadeIn();
    $(this).next(modalBg).next(modalMain).removeClass("_slideDown");
    $(this).next(modalBg).next(modalMain).addClass("_slideUp");
  });
  modalBtnClose.on('click', function (e) {
    modalBg.fadeOut();
    modalMain.removeClass("_slideUp");
    modalMain.addClass("_slideDown");
  });
  modalBtnCloseFix.on('click', function (e) {
    modalBg.fadeOut();
    modalMain.removeClass("_slideUp");
    modalMain.addClass("_slideDown");
  });
  modalMain.on('click', function (e) {
    e.stopPropagation();
  });
  modalBg.on('click', function () {
    $(this).fadeOut();
    $(this).next(modalMain).removeClass("_slideUp");
    $(this).next(modalMain).addClass("_slideDown");
  });
});

// Youtube Control
$(function(){
  $(".play").on("click", function(){
    videoControl("playVideo"); //再生
  });
  
  $(".pause").on("click", function(){
    videoControl("pauseVideo"); //一時停止
  });
  
  $(".stop").on("click", function(){
    videoControl("stopVideo"); //停止
  });
  
  $(".clear").on("click", function(){
    videoControl("clearVideo"); //クリア
  });
  
  function videoControl(action){
    let $playerWindow = $('#popup-YouTube-player')[0].contentWindow;
    $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
  }
});

// アコーディオン
$(function() {
  $(".section_qa ul li h3").on("click", function() {
    $(this).next().slideToggle();
    $(this).toggleClass('open');
  });
  
  $("._acd").on('click',function() {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle();
  });
});

$(function() {
  let headerHeight = $('.header').outerHeight();
  $('a[href^="#"]').click(function() {
    let href= $(this).attr("href");
    let target = $(href);
    let position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop:position}, 500);
    return false;
  });
});



// ========================
// Footer
// ========================

// ページTOP
function toTop() {
  const toTopBtn = document.querySelector("#toTop");
  toTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
  window.addEventListener('scroll', () => {
    const nowPosition = window.pageYOffset;
    if (nowPosition >= 250) {
      toTopBtn.style.visibility = 'visible';
      toTopBtn.style.opacity = '1';
    } else {
      toTopBtn.style.visibility = 'hidden';
      toTopBtn.style.opacity = '0';
    }
  });
  
}

function setQAIdSafely() {
  const isMobile = window.innerWidth <= 768;
  const spElement = document.querySelector('.section_qa_sp');
  const pcElement = document.querySelector('.section_qa_pc');
  
  // すでに id="qa" の要素があれば、すべて id を除去（重複防止）
  document.querySelectorAll('#qa').forEach(el => el.removeAttribute('id'));
  
  // 条件に応じて必要な要素に id を付与
  if (isMobile) {
    if (spElement) spElement.id = 'qa';
  } else {
    if (pcElement) pcElement.id = 'qa';
  }
}

// 初回実行
setQAIdSafely();

// 画面リサイズ時にも対応
window.addEventListener('resize', setQAIdSafely);

window.addEventListener("DOMContentLoaded", () => {
  toTop();
})